<template>
  <section class="min-h-screen flex items-stretch text-white bg-[#F7F7F7]">
    <div
      class="lg:flex w-1/2 hidden bg-gray-500 bg-no-repeat bg-cover relative items-center rounded-tr-[45px] rounded-br-[45px]"
      style="background-image: url(https://images.unsplash.com/photo-1577495508048-b635879837f1?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=675&q=80);">
      <div class="absolute bg-black opacity-60 inset-0 z-0 rounded-tr-[45px] rounded-br-[45px]"></div>
      <div class="w-full px-24 z-10">
        <h1 class="text-5xl font-bold text-left tracking-wide">Inclusion</h1>
        <h1 class="text-5xl font-bold text-left tracking-wide">Connection</h1>
        <h1 class="text-5xl font-bold text-left tracking-wide">Growth</h1>
      </div>
      <div class="bottom-0 absolute p-4 text-center right-0 left-0 flex justify-center space-x-4">
        <span>
          <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
              d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
          </svg>
        </span>
        <span>
          <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
              d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
          </svg>
        </span>
        <span>
          <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
              d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
          </svg>
        </span>
      </div>
    </div>
    <div class="lg:w-2/3 lg:items-center w-full flex py-6 justify-center text-center md:px-16 px-0 z-0">
      <div class="absolute lg:hidden z-10 inset-0 bg-gray-500 bg-no-repeat bg-cover items-center"
        style="background-image: url(https://images.unsplash.com/photo-1577495508048-b635879837f1?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=675&q=80);">
        <div class="absolute bg-black opacity-60 inset-0 z-0"></div>
      </div>
      <!-- Start Login Form -->
      <div id="login-card" class="sm:w-2/3 lg:w-full px-2 z-20 bg-[#f3f3f366] rounded-[36px] py-[86px]">
        <div class="flex items-center justify-center">
          <a href="#" class="flex items-center">
            <img src="../assets/images/logo.png" class="h-24" alt="Logo" />
          </a>
        </div>
        <h2 class="text-2xl font-bold my-4 justify-center text-black">
          <span class="text-[#090446]">Log In</span>
        </h2>
        <p class="text-lg justify-center text-black">Please provide your email and password to move forward</p>
        <form action="" class="sm:w-2/3 w-full px-8 lg:px-0 mx-auto">
          <div class="pb-2 pt-4">
            <input type="email" name="email" id="email" placeholder="Email"
              class="sm:bg-white lg:bg-[#f3f3f366] border border-1 border-[#DCDCDC] rounded-[6px] block w-full p-4 text-black text-lg bg-[#f3f3f366]"
              v-model="user.email">
          </div>
          <div class="pb-2 pt-4">
            <input
              class="sm:bg-white lg:bg-[#f3f3f366] border border-1 border-[#DCDCDC] rounded-[6px] block w-full p-4 text-black text-lg bg-[#f3f3f366]"
              type="password" name="password" id="password" placeholder="Password" v-model="user.password">
          </div>
          <div class="text-left sm:text-white lg:text-gray-800">
            <span class="font-bold text-[#BE0858]">
              <router-link to="/forget-password">Forgot Password?</router-link>
            </span>
          </div>
          <div class="px-[65px] py-2">
              <button
                class="block w-full py-2 text-lg rounded-[10px] bg-[#BE0858] hover:bg-[#ab064e] focus:outline-none flex items-center justify-center"
                @click="validateForm" 
                :disabled="user.disabled">
                <span v-if="user.disabled" class="mr-2">
                    <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </span>
                <span>{{ user.disabled ? 'Logging in...' : 'Log in' }}</span>
            </button>
          </div>
          <div class="text-center text-gray-400 mb-6">
            <span class="text-[#313131]">Don’t Have account ?</span>
            <router-link class="font-bold text-[#BE0858]" to="/">Subscribe Now</router-link>
          </div>

          <div class="p-4 text-center right-0 left-0 flex justify-center space-x-4 mt-16 lg:hidden ">
            <a href="#">
              <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path
                  d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
              </svg>
            </a>
            <a href="#">
              <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path
                  d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
              </svg>
            </a>
            <a href="#">
              <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
          </div>
        </form>
      </div>
      <!-- End Login Form -->

    </div>
  </section>
</template>

<script>
import Api from '../router/api' 
/* eslint-disable */
export default {
  name: 'Login',
  data() {
    return {
      hideFooter: true,
      msg: 'Login',
      user: {
        'email': '',
        'password': '',
        'disabled': false,
      },
      forgotPass: {
        'email': '',
        'disabled': false,
      }
    }
  },
  methods: {
    validateForm: function (e) {
      e.preventDefault();
      let that = this;
      if (!that.user.email || !that.user.password) 
      {
        this.$swal({
          icon: "error",
          title: "error",
          text: "Please fill all required fields",
          showConfirmButton: true
        });
      }
      else 
      {
        that.user.disabled = true;
        Api.login(that.user).then(response => {
         
          const redirectURL = localStorage.getItem('redirectURL');
          console.log({redirectURL});
          that.user.disabled = false;
          
          if(response.data.user.dashboard_tutorial_status == 1)
          {
            window.localStorage.setItem('window-driver', "window.driver");
          } 
          
          // In Condition
         
            if (response.data.company) 
            {
              if (response.data.company.role == 'COMPANY_ADMIN' && response.data.company.payment_status) 
              {
                window.localStorage.setItem('token', response.data.access_token)
                window.localStorage.setItem('userData', JSON.stringify(response.data.user))
                window.localStorage.setItem('companyData', JSON.stringify(response.data.company))
               
                if (response.data.welcome_note) 
                {
                  // console.log(response.data);
                  // alert(33)
                  if (redirectURL) 
                  {
                    localStorage.removeItem("redirectURL");
                    setTimeout(() => {
                      window.location.href = redirectURL;
                    }, 200)
                  } 
                  else 
                  {
                    window.location = '/employer/welcome-note'
                  }
                } 
                else 
                {
                  if (redirectURL) 
                  {
                    localStorage.removeItem("redirectURL");
                    setTimeout(() => {
                      window.location.href = redirectURL;
                    }, 200)
                  } 
                  else 
                  {
                    window.location = '/employer/dashboard';
                  }
                }
              } 
              else if (response.data.company.role == 'COMPANY_SUB_ADMIN') 
              {
                response.data.company.role = 'COMPANY_EMP';
                window.localStorage.setItem('token', response.data.access_token)
                window.localStorage.setItem('userData', JSON.stringify(response.data.user)) 
                window.localStorage.setItem('companyData', JSON.stringify(response.data.company))

                if (response.data.welcome_note) 
                {
                  if (redirectURL) 
                  {
                    localStorage.removeItem("redirectURL");
                    setTimeout(() => {
                      window.location.href = redirectURL;
                    }, 200)
                  } 
                  else 
                  {
                    window.location = '/employee/welcome-note'
                  }
                } 
                else 
                {
                  if (redirectURL) 
                  {
                    localStorage.removeItem("redirectURL");
                    setTimeout(() => {
                      window.location.href = redirectURL;
                    }, 200)
                  } 
                  else 
                  {
                    window.location = '/employee/dashboard/pop-up-survey'
                  }
                }
              }
              setTimeout(() => {
              if (response.data.company.role == 'COMPANY_ADMIN' && !response.data.company.payment_status) 
              {
                window.location = '/checkout/' + response.data.company.employee_registration_link
              } 
              
              else 
              {
                window.localStorage.setItem('token', response.data.access_token)
                window.localStorage.setItem('userData', JSON.stringify(response.data.user))
                window.localStorage.setItem('companyData', JSON.stringify(response.data.company))

                if (response.data.welcome_note) 
                {
                  if (redirectURL) 
                  {
                    localStorage.removeItem("redirectURL");
                    setTimeout(() => {
                      window.location.href = redirectURL;
                    }, 200)
                  } 
                  else {
                    window.location = '/employee/welcome-note'
                  }
                } 
                else 
                {
                  if (redirectURL) 
                  {
                    localStorage.removeItem("redirectURL");
                    setTimeout(() => {
                      window.location.href = redirectURL;
                    }, 1000)
                  } 
                  else 
                  {
                    window.location = '/employee/dashboard/pop-up-survey'
                  }
                }
              }
            }, 100);
            } 
            else 
            {
              window.localStorage.setItem('token', response.data.access_token)
              window.localStorage.setItem('userData', JSON.stringify(response.data.user))
              if (redirectURL) {
                localStorage.removeItem("redirectURL");
                setTimeout(() => {
                  window.location.href = redirectURL;
                }, 200)
              } else {
                window.location = '/admin/dashboard'
              }
            }

         // In Condition
        }).catch((error) => {
          console.log({ error });
          that.user.disabled = false;
          this.$swal({
            icon: "error",
            title: "error",
            text: error.response.data.message,
            showConfirmButton: true
          });
        });
      }
    },

  },
  mounted() {
    const redirectURL = localStorage.getItem('redirectURL');
    console.log({ redirectURL })
    if (this.isLoggedIn) {
      if (this.user.role == "COMPANY") {
        this.$router.push('/employer/dashbaord')
      } else if (this.user.role == "COMPANY_EMP") {
        this.$router.push('/employee/dashbaord')
      } else {
        this.$router.push('/admin/dashbaord')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-group {
  margin-bottom: 1rem;
}

.err {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue